// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"57432":"10cec4da7984f239","58519":"e3ca36435cb7915e","91373":"589d8a59a4be3154"}[chunkId] + ".css";
};